import {
  CategoryTextDto,
  PDiPOptionBasicDto,
  MenuDto,
} from 'src/services/Client';
import { IReduxState } from '../IReduxState';

export const selectSerCategories = (state: IReduxState): CategoryTextDto[] =>
  state.baseOptions.serCategories;

export const selectNonSerCategories = (state: IReduxState): CategoryTextDto[] =>
  state.baseOptions.nonSerCategories;

export const selectOptionBasicsPDiPList = (
  state: IReduxState
): PDiPOptionBasicDto[] => state.baseOptions.optionBasicsPDiPList;

export const selectBaseOptionsAreaExtraLinks = (state: IReduxState): MenuDto =>
  state.baseOptions.baseOptionsAreaExtraLinks;



// WEBPACK FOOTER //
// ./src/redux/selectors/baseOptionSelectors.ts